<template>
  <section class="d-flex flex-column h-full">
    <header class="mdc-top-app-bar">
      <div class="mdc-top-app-bar__row">
        <section
          class="mdc-top-app-bar__section mdc-top-app-bar__section--align-start"
        >
          <button
            class="material-icons mdc-top-app-bar__navigation-icon mdc-icon-button"
            aria-label="Open navigation menu"
            v-if="!showPreview"
            @click="close"
            @keypress="close"
            tabindex="0"
          >
            close
          </button>
          <button
            class="material-icons mdc-top-app-bar__navigation-icon mdc-icon-button"
            aria-label="Open navigation menu"
            v-else
            @click="close"
            @keypress="close"
            tabindex="0"
          >
            arrow_back
          </button>
        </section>
        <section
          class="mdc-top-app-bar__section title d-flex justify-content-center"
        >
          <div class="mdc-top-app-bar__title pdl-1 font-r">
            {{ $t("3361") }}
          </div>
        </section>
        <section
          class="mdc-top-app-bar__section mdc-top-app-bar__section--align-end"
          role="toolbar"
        >
          <button
            class="material-icons mdc-top-app-bar__navigation-icon mdc-icon-button"
          ></button>
        </section>
      </div>
    </header>
    <main class="mdc-top-app-bar--fixed-adjust" v-if="!showPreview">
      <section class="d-flex flex-column h-full">
        <div class="flex-grow-1 scroll-y">
          <div class="position-relative pdt-16 pdl-16 pdb-16 pdr-16">
            <div class="d-flex align-items-center">
              <div class="flex-grow-1">
                <div class="t-subtitle5 l-spacing54 font-m t-line-h-26">
                  {{
                    indexGroupData
                      ? indexGroupData.name || "월간 청소 및 위생 관리"
                      : "월간 청소 및 위생 관리"
                  }}
                </div>
                <div
                  class="t-helper l-spacing36 t-line-h-24 t-color-bodyGrayA mgt-2 font-r"
                  v-if="increaseCount == totalArrayLength"
                >
                  {{ $t("3385") }}
                </div>
                <div
                  class="t-helper l-spacing36 t-line-h-24 t-color-bodyGrayA mgt-2 font-r"
                  v-else
                >
                  {{
                    distributionDetail && distributionDetail[increaseCount]
                      ? $t("3449") +
                          ": " +
                          distributionDetail[increaseCount].name ||
                        "Distribution Detail"
                      : "Distribution Detail"
                  }}
                </div>
              </div>
              <div class="process-circle-container">
                <div
                  class="progress-circle p100"
                  :class="circleDegree > 180 ? 'over50' : ''"
                >
                  <div class="content">
                    <span
                      class="t-subtitle5 l-spacing54 font-rn t-line-h-26 pdr-4"
                      >{{ increaseCount }}</span
                    >
                    <span
                      class="t-subtitle5 l-spacing54 font-rn t-line-h-26 t-color-bodyGrayA"
                    >
                      / {{ totalArrayLength }}</span
                    >
                    <span class="circle-left"></span>
                  </div>
                  <div class="left-half-clipper">
                    <div class="first50-bar"></div>
                    <div
                      class="value-bar"
                      :style="'transform: rotate(' + circleDegree + 'deg);'"
                    ></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="divider"></div>

          <section
            class="flex-grow-1 scroll-y"
            v-if="indexGroupData && indexGroupData.questions"
          >
            <div
              v-for="(myData, index) in indexGroupData.questions"
              :key="index + '_dk'"
            >
              <AnswerType
                :numberValue="index + 1"
                :form="formWithIndex[index + 1]"
                :validField="validateField[index]"
                :checkListData="myData.question"
                v-if="
                  myData.question.type.value === 'NUMBER' ||
                  myData.question.type.value === 'TEXT'
                "
              />
              <ChoiceSingle
                :numberValue="index + 1"
                :form="formWithIndex[index + 1]"
                :validField="validateField[index]"
                :checkListData="myData.question"
                v-if="myData.question.type.value === 'CHOICE_SINGLE'"
              />
              <ChoiceMultiple
                :numberValue="index + 1"
                :form="formWithIndex[index + 1]"
                :validField="validateField[index]"
                :checkListData="myData.question"
                v-if="myData.question.type.value === 'CHOICE_WORKS'"
              />
              <DateInput
                :numberValue="index + 1"
                :form="formWithIndex[index + 1]"
                :validField="validateField[index]"
                :checkListData="myData.question"
                v-if="myData.question.type.value === 'DATE'"
              />
              <ShortAnswer
                ref="short_annswer_ref"
                :numberValue="index + 1"
                :form="formWithIndex[index + 1]"
                :validField="validateField[index]"
                :checkListData="myData.question"
                v-if="myData.question.type.value === 'SHORT_ANSWER'"
              />
            </div>
          </section>
        </div>
        <div class="h-100"></div>
        <section class="bottom-shadow fixed-bottom-footer w-full bg-white">
          <div class="pdb-34">
            <div
              class="d-flex flex-row justify-content-between align-items-center pdt-10 pdb-10 pdl-8 pdr-8"
            >
              <div style="width: 120px">
                <button
                  class="mdc-button btn-white t-color-logoBlue t-nowrap"
                  @click="prev()"
                  @keypress="prev()"
                  v-if="increaseCount > 1"
                  tabindex="0"
                >
                  <i class="material-icons mdc-button__icon pdr-8 mgr-0"
                    >keyboard_arrow_left</i
                  >{{ $t("3384") }}
                </button>
              </div>
              <div></div>
              <div
                class="t-right"
                style="width: 120px"
                @click="next()"
                @keypress="next()"
                v-if="increaseCount < totalArrayLength"
                tabindex="0"
              >
                <button
                  class="mdc-button btn-white t-color-logoBlue t-nowrap font-m"
                >
                  {{ $t("3383") }}
                  <i class="material-icons mdc-button__icon pdl-8 mgr-0"
                    >keyboard_arrow_right</i
                  >
                </button>
              </div>

              <div
                class="t-right"
                style="width: 120px"
                @click="showPrev()"
                @key="showPrev()"
                v-if="increaseCount == totalArrayLength"
                tabindex="0"
              >
                <button
                  class="mdc-button btn-white t-color-logoBlue t-nowrap font-m"
                >
                  {{ $t("3389") }}
                  <i class="material-icons mdc-button__icon pdl-8 mgr-0"
                    >keyboard_arrow_right</i
                  >
                </button>
              </div>
            </div>
          </div>
        </section>
      </section>
    </main>
    <Preview
      v-if="showPreview"
      ref="preview"
      :dataId="dataId"
      :formDataAllStep="formDataAllStep"
      :distributionDetail="distributionDetail"
    />
  </section>
</template>

<script>
import { topAppBarMixin } from "../../mixins/topAppBar.js";
import checklistApi from "@/api/checklistApi.js";
import Preview from "./preview/preview.vue";

export default {
  data() {
    return {
      showPreview: false,
      distributionDetail: [],
      indexGroupData: null,
      indexCount: 0,
      totalArrayLength: null,
      increaseCount: 1,
      circleDegree: 0,
      formDataAllStep: [],
      formWithIndex: {},
      submittedData: {},
      dataId: null,
      validateField: [],
    };
  },

  components: {
    AnswerType: () => import("./question/AnswerType.vue"),
    ChoiceSingle: () => import("./question/ChoiceSingle.vue"),
    ChoiceMultiple: () => import("./question/ChoiceMultiple.vue"),
    DateInput: () => import("./question/DateInput.vue"),
    ShortAnswer: () => import("./question/ShortAnswer.vue"),
    Preview,
  },

  mixins: [topAppBarMixin],

  watch: {
    $route(to, from) {
      this.initData();
    },
  },

  mounted() {
    if (this.$route.query.groupIndex) {
      this.increaseCount = this.$route.query.groupIndex;
      this.indexCount = this.increaseCount - 1;
    }
    checklistApi
      .getQuestionList(this.$route.params)
      .then((response) => {
        console.log("response >>> ", response);
        this.distributionDetail =
          response.data.data.activeRespondentPaper.groups;

        this.dataId = response.data.data.id;
        this.totalArrayLength = this.distributionDetail.length;
        this.indexGroupData = this.distributionDetail[this.indexCount];

        this.createForm();
        this.countCircle();
        if (this.increaseCount > 1) {
          this.setPreviousData();
        }
      })
      .catch((err) => {
        console.log("errror=> ", err);
        this.$error({ content: err.errMsg }).then(() => {});
      });
  },

  // beforeRouteLeave(to, from, next) {
  //   this.temprorayDataSave();
  //   next();
  // },

  methods: {
    setPreviousData() {
      /// outer looop settting data previous step
      for (let i = 0; i < this.indexCount; i++) {
        let formIndexData = {};
        /// inner looop settting data previous step
        for (let j = 0; j < this.distributionDetail[i].questions.length; j++) {
          let formFormat = {
            text: "",
            comment: "",
            selected: [],
            weight: {},
            works: [],
            isSolved: true,
            image: null,
          };
          if (
            this.distributionDetail[i].questions[j].type === "CHOICE_SINGLE"
          ) {
            this.distributionDetail[i].questions[j].choices.forEach((value) => {
              if (value.weight) {
                formFormat.selected.push(true);
              } else {
                formFormat.selected.push(false);
              }
            });
          } else if (
            this.distributionDetail[i].questions[j].type === "CHOICE_WORKS"
          ) {
            this.distributionDetail[i].questions[j].works.forEach((value) => {
              if (value.id) {
                formFormat.works.push(value.id);
              }
            });
          } else {
            formFormat.text =
              this.distributionDetail[i].questions[j].questionTextReply;
          }
          formFormat.comment = this.distributionDetail[i].questions[j].comment;
          formFormat.image = this.distributionDetail[i].questions[j].image;
          formIndexData[j + 1] = formFormat;
        }
        this.formDataAllStep.push(formIndexData);
      }
    },
    next() {
      this.validateField = this.checkValidation();
      if (this.validateField.includes(true)) {
        return;
      } else {
        this.indexGroupData = null;
        setTimeout(() => {
          if (this.formDataAllStep[this.indexCount] === undefined) {
            this.formDataAllStep.push(this.formWithIndex);
          }
          this.indexCount += 1;
          this.increaseCount += 1;

          this.indexGroupData = JSON.parse(
            JSON.stringify(this.distributionDetail[this.indexCount])
          );
          this.countCircle();
          if (this.formDataAllStep[this.indexCount] === undefined) {
            this.createForm();
          } else {
            this.formWithIndex = this.formDataAllStep[this.indexCount];
          }
          window.scrollTo({ top: 0, behavior: "smooth" });
        }, 100);
      }
    },
    checkValidation() {
      let returnValiDationArray = [];
      this.indexGroupData.questions.forEach((value, index) => {
        if (value.question.type.value == "CHOICE_SINGLE") {
          if (this.formWithIndex[index + 1].selected.includes(true)) {
            returnValiDationArray.push(false);
          } else {
            returnValiDationArray.push(true);
          }
        } else if (value.question.type.value == "CHOICE_WORKS") {
          if (this.formWithIndex[index + 1].works.length > 0) {
            returnValiDationArray.push(false);
          } else {
            returnValiDationArray.push(true);
          }
        } else {
          if (this.formWithIndex[index + 1].text) {
            returnValiDationArray.push(false);
          } else {
            returnValiDationArray.push(true);
          }
        }
      });
      return returnValiDationArray;
    },
    prev() {
      this.validateField = [];
      this.indexGroupData = {};
      setTimeout(() => {
        this.indexCount -= 1;
        this.formWithIndex = this.formDataAllStep[this.indexCount];
        this.increaseCount -= 1;
        this.indexGroupData = JSON.parse(
          JSON.stringify(this.distributionDetail[this.indexCount])
        );
        this.countCircle();
        window.scrollTo({ top: 0, behavior: "smooth" });
      }, 10);
    },
    countCircle() {
      let totalDegree = 360;
      this.circleDegree =
        (totalDegree * this.increaseCount) / this.totalArrayLength;
    },
    showPrev() {
      this.validateField = this.checkValidation();
      if (this.validateField.includes(true)) {
        return;
      } else {
        if (this.formDataAllStep[this.indexCount] === undefined) {
          this.formDataAllStep.push(this.formWithIndex);
        }
        this.showPreview = true;
        window.scrollTo({ top: 0, behavior: "smooth" });
      }
    },
    close() {
      if (this.showPreview) {
        this.showPreview = false;
      } else {
        let params = {
          title: this.$t("3394"),
          content: this.$t("3395"),
          accept: this.$t("3397"),
          cancel: this.$t("3396"),
        };
        this.$confirm(params)
          .then((res) => {
            this.temprorayDataSave();
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    temprorayDataSave() {
      let formFormat = {
        text: "",
        comment: "",
        selected: [],
        weight: {},
        works: [],
        isSolved: false,
        images: null,
      };
      let submitAllQuestionData = {};
      // formDataAllStep 복사 (깊은 복사)
      let allSteps = JSON.parse(JSON.stringify(this.formDataAllStep));
      // 현재 그룹 답변 반영
      allSteps[this.indexCount] = this.formWithIndex;
      for (let i = 0; i < this.distributionDetail.length; i++) {
        for (let j = 0; j < this.distributionDetail[i].questions.length; j++) {
          let id = this.distributionDetail[i].questions[j].question.id;
          if (allSteps[i] != undefined && allSteps[i][j + 1]) {
            submitAllQuestionData[id] = allSteps[i][j + 1];
          } else {
            submitAllQuestionData[id] = formFormat;
          }
        }
      }
      this.submitTemporaryResults(submitAllQuestionData, this.dataId);
    },
    submitTemporaryResults(data, id) {
      this.$showLoading();
      checklistApi
        .submitCheckListTemp(data, id)
        .then((response) => {
          this.$hideLoading();
          this.$router.push({
            name: "CheckListView",
            params: { postId: this.$route.params.postId },
          });
        })
        .catch((err) => {
          this.$hideLoading();
        });
    },
    createForm() {
      // formFormat의 기본 구조 정의
      let myFormArray = {};
      let returnValiDationArray = [];
      // 각 질문별로 타입과 기존 답변을 반영하여 formFormat을 생성
      for (let i = 0; i < this.indexGroupData.questions.length; i++) {
        const questionObj = this.indexGroupData.questions[i];
        const question = questionObj.question;
        let formFormat = {
          text: "",
          comment: "",
          selected: [],
          weight: {},
          works: [],
          isSolved: true,
          images: null,
        };
        // 단일 선택형(CHOICE_SINGLE)인 경우, 선택된 항목을 selected 배열에 true/false로 반영
        if (question.type.value === "CHOICE_SINGLE" && questionObj.choices) {
          questionObj.choices.forEach((choice) => {
            formFormat.selected.push(!!choice.weight);
          });
          // 다중 선택형(CHOICE_WORKS)인 경우, works 배열에 선택된 work id를 추가
        } else if (
          question.type.value === "CHOICE_WORKS" &&
          questionObj.works
        ) {
          questionObj.works.forEach((work) => {
            if (work.id) formFormat.works.push(work.id);
          });
          // 그 외(텍스트, 숫자 등)인 경우, 기존 답변을 text에 반영
        } else {
          console.log(`#${i} >>> `, questionObj.questionTextReply);
          formFormat.text = questionObj.questionTextReply || "";
        }
        // 코멘트와 이미지도 기존 값이 있으면 반영
        formFormat.comment = questionObj.comment || "";
        formFormat.images = questionObj.images || null;
        // myFormArray에 formFormat 저장 (1부터 시작하는 인덱스)
        myFormArray[i + 1] = formFormat;
        // 유효성 배열 초기화
        returnValiDationArray.push(false);
      }
      // 유효성 배열 및 formWithIndex에 값 할당
      this.validateField = returnValiDationArray;
      this.formWithIndex = JSON.parse(JSON.stringify(myFormArray));
    },
  },
};
</script>
<style scoped>
</style>
